export const ORDER_TYPE_ART = 'art'
export const ORDER_TYPE_CART = 'cart'
export const ORDER_TYPE_PRODUCT = 'product' // Enables ordering a single cart item consisting of tiles (same structure as in CartContext.addItem)

export type CheckoutOrderType =
  | typeof ORDER_TYPE_CART
  | typeof ORDER_TYPE_PRODUCT
